import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';

import { addModal } from 'core/notifications';

import { Insignias } from 'uikit/insignias';
import { Skeleton } from 'uikit/loaders';
import { Typo } from 'uikit/content';

import CredentialModalContainer from '../containers/credentialModalContainer';
import ProfileCredentialsCategoryList from './profileCredentialsCategoryList';

import styles from '../styles/profileCredentials.module.scss';

const ProfileCredentials = ({
  data = [],
  gamification = {},
  isCurrentUser = false,
  isLoading = true,
  isMyLearning = false,
}) => {
  const handleCredentialClick = (id) => {
    addModal({
      component: <CredentialModalContainer id={id} gamification={gamification} />,
      hasCloseButton: true,
    });
  };

  const uncategorized = {
    name: i18n.t('more-credentials'),
    credentials: [],
  };

  const categorized = data.reduce((acc, curr) => {
    const ind = acc.findIndex((e) => e.name === curr.credential_type);
    if (ind > -1) {
      acc[ind].credentials.push(curr);
    } else if (curr.credential_type !== '') {
      acc.push({
        name: curr.credential_type,
        credentials: [curr],
      });
    } else {
      uncategorized.credentials.push(curr);
    }
    return acc;
  }, []);

  if (uncategorized.credentials.length) {
    categorized.push(uncategorized);
  }

  const credentialsCount = data.length;

  const insignias = [
    {
      ariaLabel: i18n.t('count-credentials', { count: credentialsCount }),
      icon: 'credential',
      text: credentialsCount ? credentialsCount.toString() : '0',
      tooltip: i18n.t('credentials'),
    },
  ];

  return (
    <section className={styles.container}>
      <header className={styles.header}>
        <Typo element="h2" variant="d02">
          {i18n.t('credentials')}
        </Typo>
        {isLoading ? (
          <Skeleton className={styles.insignias} width={50} height={26} />
        ) : (
          <Insignias className={styles.insignias} insigniasIconSize={18} insignias={insignias} />
        )}
      </header>
      <ProfileCredentialsCategoryList
        categories={categorized}
        isCurrentUser={isCurrentUser}
        isLoading={isLoading}
        isMyLearning={isMyLearning}
        onCredentialClick={handleCredentialClick}
      />
    </section>
  );
};

ProfileCredentials.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      credential_type: PropTypes.string.isRequired,
    }),
  ),
  gamification: PropTypes.shape({
    data: PropTypes.shape({
      is_gold_enabled: PropTypes.bool,
      gold_redeem_url: PropTypes.string,
      has_reached_gold_limit: PropTypes.bool,
      gold_balance: PropTypes.number,
    }),
  }),
  isCurrentUser: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMyLearning: PropTypes.bool,
};

export default React.memo(ProfileCredentials);
